import React from 'react';
import { useApp } from '../context/AppContext';
import Seal from './Seal';

// The QPS seal in a nav bar, as a link home.
//
// Every site puts its logo top-left and every visitor expects it to take them
// back to the start — it's the one navigation control people try without being
// told. Wrapping the seal in a real <button> also gets keyboard focus and a
// screen-reader label for free, which a bare <svg> in a <div> never had.
//
// The big seal in the homepage hero is deliberately not this: you're already
// home there, and a 112px button reads as something to press.

export default function BrandMark({ size = 30, className = 'brand', style }) {
  const { goTo } = useApp();
  return (
    <div className={className} style={style}>
      <button type="button" className="brandmark" aria-label="Home" onClick={() => goTo('screen-home')}>
        <Seal size={size} />
      </button>
    </div>
  );
}
